module.exports = __webpack_public_path__ + "img/edu-road-4.43b52909.png";